import { registerLicense } from "@syncfusion/ej2-base";
import { environment } from "./environments/environment";
import { enableProdMode, APP_INITIALIZER } from "@angular/core";
import { AppComponent } from "./app/app.component";
import { APP_ROUTES } from "./app/app.routes";
import { provideToastr } from "ngx-toastr";
import { provideAnimations } from "@angular/platform-browser/animations";
import { bootstrapApplication } from "@angular/platform-browser";
import { UserIdleConfig, WSSyncFusionGridConfig } from "wspowerpack";
import { API_BASE_URL } from "./app/api/client";
import { AuthService } from "./app/modules/core/services/auth.service";
import { Http500Interceptor } from "./app/modules/core/interceptors/Http500.interceptor";
import { AuthInterceptor } from "./app/modules/core/interceptors/auth.interceptor";
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from "@angular/common/http";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { CustomRouteReuseStrategyV2 } from "./app/modules/core/CustomRouteReuseStrategyV2";

const GRID_CONFIG: WSSyncFusionGridConfig = {
  apiRoot: environment.apiRoot + "/",
};

const userIdleConfig: UserIdleConfig = {
  idle: environment.idle,
  timeout: 30, //seconds
  ping: 120,
};

const appInitializerFn = (appConfig: AuthService) => {
  return () => {
    return appConfig.initializeApp();
  };
};

if (environment.production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, {
  providers: [
    { provide: API_BASE_URL, useValue: environment.apiRoot },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http500Interceptor,
      multi: true,
    },
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: UserIdleConfig,
      useValue: userIdleConfig,
    },
    {
      provide: WSSyncFusionGridConfig,
      useValue: GRID_CONFIG,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTES),
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategyV2,
    },
    provideToastr({
      positionClass: "toast-bottom-right",
    }),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
// Registering Syncfusion license key
registerLicense("ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9TdEViWnpdc3dcRmlY");
